import { cn } from '@/lib/utils'

export interface CaseProcessingTimeDescriptionProps {
  estimatedTime?: number
  unit?: string
  className?: {
    root?: string
    titleText?: string
    valueText?: string
    errorText?: string
  }
}

export const CaseProcessingTimeDescription = ({
  estimatedTime,
  unit,
  className,
}: CaseProcessingTimeDescriptionProps) => {
  const existsData = !!(estimatedTime && unit)

  return (
    <div
      className={cn(
        'rounded-[9px]',
        'bg-secondary',
        'px-4 pb-3 pt-2.5',
        'text-xs font-normal leading-6',
        className?.root
      )}
    >
      {existsData && (
        <>
          <p className={cn(className?.titleText)}>80% of cases are completed within</p>
          <span className={cn('text-lg font-medium leading-6', className?.valueText)}>
            {`${estimatedTime} ${unit}`}
          </span>
        </>
      )}
      {!existsData && (
        <p className={cn('text-red-600', className?.errorText)}>
          Please check case category and service center. The processing time is displayed only if USCIS provides data
          for this specific category and service center.
        </p>
      )}
    </div>
  )
}
